module.exports = __webpack_public_path__ + "img/s-cross-color.67741e8c.svg";